import { ChevronDown, Hits } from '../../../modules/design-system';

type Props = {
  onClick: () => void;
};

/** The phone's "What's Inside ⌃" pill under the pack title (repackz-handoff
 *  §7.3): 28 tall glass, cup icon, chevron up — opens the sheet. */
export function WhatsInsideButton({ onClick }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-haspopup="dialog"
      className="flex h-7 shrink-0 cursor-pointer items-center gap-1.5 rounded-full px-2.5 text-[13px] font-semibold leading-5 tracking-[-0.2px] text-white [background:var(--glass-pill-fill)] transition-transform active:scale-95"
    >
      <Hits size={16} className="shrink-0" />
      {"What's Inside"}
      <ChevronDown size={16} strokeWidth={2.25} className="shrink-0 rotate-180" />
    </button>
  );
}
